import { Avatar } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { DesignToken } from '~c/components/base/core';
import { Bank } from '~c/components/base/icon';

interface Props {
  className?: string;
}

// TODO: use policy icon and color
const PolicyAvatarImpl: React.FC<Props> = ({ className }) => {
  return (
    <Avatar className={className}>
      <Bank />
    </Avatar>
  );
};

export const PolicyAvatar = muiStyled(PolicyAvatarImpl)(({ theme }) => {
  return css`
    width: 56px;
    height: 56px;
    background-color: ${DesignToken.status.success};
  `;
});

export default PolicyAvatar;
